import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiFilter, FiX, FiRefreshCw, FiCheck } from "react-icons/fi";

const FilterModel = ({ isOpen, onClose, onApply }) => {
  const [localFilters, setLocalFilters] = useState({
    per_page: 10,
    page: 1,
    order_by: "created_at",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const applyFilters = () => {
    onApply(localFilters);
  };

  const resetFilters = () => {
    const defaultFilters = {
      per_page: 10,
      page: 1,
      order_by: "created_at",
    };
    setLocalFilters(defaultFilters);
    onApply(defaultFilters);
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900/60 backdrop-blur-sm z-50 p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 15 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 15 }}
          transition={{ duration: 0.2 }}
          className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden border border-gray-100 flex flex-col"
        >
          {/* Header Filter */}
          <div className="p-5 border-b border-gray-100 flex items-center justify-between bg-gradient-to-r from-blue-50 to-indigo-50">
            <div className="flex items-center gap-3">
              <div className="p-2.5 rounded-2xl bg-blue-600 text-white shadow-md shadow-blue-500/20">
                <FiFilter className="w-5 h-5" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-gray-900">Filter Karyawan</h2>
                <p className="text-xs text-gray-500">Filter data karyawan & penempatan</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-xl text-gray-400 hover:text-gray-700 hover:bg-white/80 transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>

          {/* Form Body */}
          <div className="p-6 space-y-4 text-xs font-medium">
            {/* Order By */}
            <div className="space-y-1.5">
              <label className="text-gray-700 font-bold uppercase text-[10px] tracking-wider">
                Urutkan Berdasarkan (Order By)
              </label>
              <select
                name="order_by"
                value={localFilters.order_by}
                onChange={handleChange}
                className="w-full p-3 bg-gray-50 border border-gray-200 rounded-2xl text-xs text-gray-800 font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
              >
                <option value="created_at">Tanggal Dibuat (Terbaru)</option>
                <option value="name">Nama Karyawan (A-Z)</option>
              </select>
            </div>

            {/* Per Page */}
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <label className="text-gray-700 font-bold uppercase text-[10px] tracking-wider">
                  Item Per Halaman
                </label>
                <select
                  name="per_page"
                  value={localFilters.per_page}
                  onChange={handleChange}
                  className="w-full p-3 bg-gray-50 border border-gray-200 rounded-2xl text-xs text-gray-800 font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                >
                  <option value={5}>5 Baris</option>
                  <option value={10}>10 Baris</option>
                  <option value={25}>25 Baris</option>
                  <option value={50}>50 Baris</option>
                </select>
              </div>

              <div className="space-y-1.5">
                <label className="text-gray-700 font-bold uppercase text-[10px] tracking-wider">
                  Halaman Ke-
                </label>
                <input
                  type="number"
                  name="page"
                  min={1}
                  value={localFilters.page}
                  onChange={handleChange}
                  className="w-full p-3 bg-gray-50 border border-gray-200 rounded-2xl text-xs text-gray-800 font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                />
              </div>
            </div>
          </div>

          {/* Action Buttons Footer */}
          <div className="p-4 border-t border-gray-100 flex items-center justify-between gap-3 bg-gray-50/50">
            <button
              onClick={resetFilters}
              className="px-4 py-2.5 rounded-2xl bg-gray-200 hover:bg-gray-300 text-gray-700 text-xs font-semibold transition-colors flex items-center gap-1.5"
            >
              <FiRefreshCw className="w-3.5 h-3.5" />
              <span>Reset</span>
            </button>

            <div className="flex items-center gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2.5 rounded-2xl bg-white border border-gray-200 hover:bg-gray-100 text-gray-700 text-xs font-semibold transition-colors"
              >
                Batal
              </button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={applyFilters}
                className="px-5 py-2.5 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs font-bold shadow-lg shadow-blue-600/20 transition-all flex items-center gap-1.5"
              >
                <FiCheck className="w-4 h-4" />
                <span>Terapkan</span>
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default FilterModel;
